import { render, staticRenderFns } from "./SalesOrganizetionModal.vue?vue&type=template&id=b67064fe&"
import script from "./SalesOrganizetionModal.vue?vue&type=script&lang=js&"
export * from "./SalesOrganizetionModal.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrganizetionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports